// Rank assignment for rank_within_item.
// order: clicks receive the values from highest to lowest.
// most_least: first click is the highest, second is the lowest, the rest fill the middle.

export function rankSequence(mode, values) {
  const unique = [...new Set(values.map(Number))].sort((a, b) => a - b)
  if (mode === "most_least") {
    if (unique.length === 0) return []
    const max = unique[unique.length - 1]
    const min = unique[0]
    const middle = unique.filter((value) => value !== max && value !== min)
    return [max, min, ...middle]
  }
  return [...unique].reverse()
}

export function assignRank(mode, values, used) {
  const taken = new Set(used.map(Number))
  return rankSequence(mode, values).find((value) => !taken.has(value)) ?? null
}
